import React, { useState } from "react";
import { connect } from "react-redux";
import { any, arrayOf, bool, func, shape, string } from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import ReadingStatus from "../ReadingListDownload/reading_status";
import {
  markDocumentReadMolecular,
  postMolecularForms,
} from "../../redux/actions";
import * as style from "../ReadingListDownload/styles.module.scss";
import OnboardingListItem from "../OnboardingListItem/OnboardingListItem";
import { getPDF } from "../../api/profileApi";
import ReadingListDownload from "../ReadingListDownload/index";
import { Button } from "../../common/index";

const MolecularOnboarding = ({
  appData,
  readingList,
  readingListDocs,
  molecularReadingListLoading,
  molecularAssessmentLoading,
  markDocumentReadFunc,
  postMolecularFormsFunc,
}) => {
  const [currentlyReading, setCurrentlyReading] = useState(null);
  const readDocuments =
    (appData.molecularOnboarding &&
      appData.molecularOnboarding.readDocuments) ||
    [];
  const [loading, setLoading] = useState(false);
  const [curTypeCode, setCurTypeCode] = useState("");
  const [showCheckbox, setShowCheckbox] = useState("");

  const candidateName = `${appData.firstName} ${appData.lastName}`;

  const testResults =
    appData.molecularOnboarding &&
    appData.molecularOnboarding.literacyTestResults;

  const testSubmitted = testResults && appData.molecularOnboarding.YML3;

  const filenameFromUrl = (url) => url.split("/").slice(-1)[0];

  const isFormCompleted = (typeCode) =>
    !!(appData.molecularOnboarding && appData.molecularOnboarding[typeCode]);

  const readingListWithStatus = readingList.map((download) => ({
    ...download,
    status: readDocuments.includes(filenameFromUrl(download.link))
      ? ReadingStatus.Done
      : ReadingStatus.Todo,
  }));

  const lockerAndBadgesUmbracoDoc = readingListDocs[0];
  const lockerAndBadgesDoc = {
    ...lockerAndBadgesUmbracoDoc,
    status: isFormCompleted(lockerAndBadgesUmbracoDoc.typeCode) ? 3 : 1,
    text: "Download",
    loading: loading && curTypeCode === lockerAndBadgesUmbracoDoc.typeCode,
  };
  const triggerDownload = (formTitle, typeCode) => {
    setLoading(true);
    setCurTypeCode(typeCode);
    getPDF(typeCode).then((response) => {
      const link = document.createElement("a");
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `${formTitle}`;
      link.click();
      setLoading(false);
      setCurTypeCode("");
    });
  };

  const isiOSDevice = () => {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  };
  const isDownloadAttrSupported = () =>
    "download" in document.createElement("a");

  const handleLockerAndBadgesReading = (e) => {
    window.open(lockerAndBadgesDoc.link, "_blank");
    if (isiOSDevice() || !isDownloadAttrSupported()) {
      e.preventDefault();
    }
    setCurrentlyReading(lockerAndBadgesDoc.title);
    setShowCheckbox(lockerAndBadgesDoc.title);
  };

  const handleLockerAndBadgesDownload = () =>
    triggerDownload(
      "Molecular_Disclaimers_RE_Lockers_Products.pdf",
      lockerAndBadgesDoc.typeCode
    );

  const handleLockerAndBadgesCheckbox = () => {
    postMolecularFormsFunc(lockerAndBadgesDoc.typeCode, {
      signature: candidateName,
      name: candidateName,
      date: moment().format("DD/MM/YYYY"),
    });
    setShowCheckbox("");
    setCurrentlyReading(null);
  };

  const drugAlcoholTestingForm = {
    status: isFormCompleted("YML1"),
    title: "Consent for Random Drug / Alcohol Testing",
    url: "molecular-onboarding/consent-drug-alcohol",
    handleClick: isFormCompleted("YML1")
      ? () =>
          triggerDownload(
            "Molecular consent for random drug/alcohol testing.pdf",
            "YML1"
          )
      : null,
  };

  const assessmentWithStatus = {
    status: isFormCompleted("YML3") ? 3 : 1,
    title: "Numeracy & Literacy Test",
    text: "Complete",
    url: "molecular-onboarding/literacy-assessment",
    downloadingDisabled: true,
    loading: molecularAssessmentLoading,
    submitted: testSubmitted,
    disabled: molecularAssessmentLoading,
  };

  const assessmentScore = () =>
    Object.values(testResults).reduce((a, b) => a + b.correctAnswered, 0);

  const assessmentScorePercentage = () =>
    Math.floor((assessmentScore() / 50) * 100);

  return (
    <div className="container text-bluishGray pb-2">
      <header className="row">
        <div className="col-12">
          <h2 className="section-header pt-2">Molecular Onboarding</h2>
        </div>
      </header>
      <div className="row">
        <div className="col-lg-6">
          <div className="section-body pt-1 mb-2 bg-white">
            <h5 className="px-1">Reading List</h5>
            <p className="p-1" style={{ width: "90%" }}>
              You are required to download and read each document below before
              you start work. You will then be asked to tick the box to confirm
              you have read and understood and agree to each document. If you
              have any queries, please speak to your HRGO Consultant.
            </p>
            {readingListWithStatus &&
              readingListWithStatus.map((elem, i) => (
                <ReadingListDownload
                  key={i}
                  title={elem.title}
                  link={elem.link}
                  status={elem.status}
                  currentlyReading={currentlyReading}
                  setCurrentlyReading={setCurrentlyReading}
                  markDocumentRead={markDocumentReadFunc}
                  isLoading={molecularReadingListLoading}
                  agreementText={elem.agreementText}
                />
              ))}
            {showCheckbox === lockerAndBadgesDoc.title ? (
              <div
                key={lockerAndBadgesDoc.title}
                className={`${style.rldownload__wrapper} ${style.rldownload__wrapper__reading}`}
              >
                <span className={style.rldownload__agreement}>
                  <input
                    type="checkbox"
                    name="document_read"
                    value={lockerAndBadgesDoc.title}
                    onClick={() => handleLockerAndBadgesCheckbox()}
                  />
                  I have read and understood the information and agree to these
                  deductions if I do not return all items.
                </span>
                <button
                  onClick={() => {
                    setShowCheckbox(null);
                    setCurrentlyReading(null);
                  }}
                  className={`${style.rldownload__button} btn btn-md btn-outline mx-1 mx-sm-0`}
                >
                  Cancel
                </button>
              </div>
            ) : (
              <div
                key={lockerAndBadgesDoc.link}
                className={`${style.rldownload__wrapper}`}
              >
                <div className={`${style.rldownload__mobile_row}`}>
                  <div
                    className={`${style.rldownload__status} ${
                      lockerAndBadgesDoc.status === ReadingStatus.Todo
                        ? style.rldownload__todo
                        : style.rldownload__done
                    }`}
                  >
                    {lockerAndBadgesDoc.status === ReadingStatus.Todo
                      ? "To Do"
                      : "Done"}
                  </div>
                  <span className={`${style.rldownload__title}`}>
                    {lockerAndBadgesDoc.title}{" "}
                  </span>
                </div>
                {
                  <a
                    onClick={
                      lockerAndBadgesDoc.status === ReadingStatus.Todo
                        ? handleLockerAndBadgesReading
                        : handleLockerAndBadgesDownload
                    }
                    download={lockerAndBadgesDoc.filename}
                    style={{ cursor: "pointer" }}
                    className={`${style.rldownload__button} ${
                      style.rldownload__download
                    } btn btn-md btn-outline ${
                      (currentlyReading !== null &&
                        lockerAndBadgesDoc.status === ReadingStatus.Todo) ||
                      lockerAndBadgesDoc.loading
                        ? "disabled"
                        : ""
                    }`}
                  >
                    Download
                  </a>
                }
              </div>
            )}
            <div className={`${style.rldownload__wrapper}`}>
              <div className={`${style.rldownload__mobile_row}`}>
                <div
                  className={`${style.rldownload__status} ${
                    drugAlcoholTestingForm.status
                      ? style.rldownload__done
                      : style.rldownload__todo
                  }`}
                >
                  {drugAlcoholTestingForm.status ? "Done" : "To Do"}
                </div>
                <span className={`${style.rldownload__title}`}>
                  {drugAlcoholTestingForm.title}{" "}
                </span>
              </div>
              {drugAlcoholTestingForm.status ? (
                <button
                  className={`${style.rldownload__button} ${style.rldownload__download} btn btn-md btn-outline `}
                  onClick={drugAlcoholTestingForm.handleClick}
                >
                  Download
                </button>
              ) : (
                <Link
                  className={`${style.rldownload__button} ${
                    style.rldownload__download
                  } btn btn-md btn-outline ${
                    currentlyReading !== null ? "disabled" : ""
                  }`}
                  to={drugAlcoholTestingForm.url}
                >
                  Complete
                </Link>
              )}
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="section-body pt-1 mb-2 bg-white">
            <h5 className="px-1">Test</h5>
            <p className="p-1">
              Please complete the test below. If you have any queries about the
              test, please speak to your HRGO Consultant.
            </p>
            <OnboardingListItem
              title={assessmentWithStatus.title}
              status={assessmentWithStatus.status}
              btnText={assessmentWithStatus.text}
              key={assessmentWithStatus.title}
              url={assessmentWithStatus.url}
              downloadingDisabled={assessmentWithStatus.downloadingDisabled}
              loading={assessmentWithStatus.loading}
            />
          </div>
          {testSubmitted && (
            <div className="section-body bg-white py-2 my-1 mt-lg-0">
              <h5 className="px-1">Test Results</h5>
              {Object.values(testResults).map((result) => (
                <div
                  key={result.sectionNumber}
                  style={{
                    display: "flex",
                    padding: "0 1rem",
                    justifyContent: "space-between",
                  }}
                >
                  <p>Section {result.sectionNumber}</p>
                  <p>
                    {result.correctAnswered}/{result.numberOfQuestions}
                  </p>
                </div>
              ))}
              <div
                style={{
                  display: "flex",
                  padding: "0 1rem",
                  justifyContent: "space-between",
                }}
              >
                <p>
                  <b>SCORE</b>
                </p>
                <p>
                  <b>
                    {assessmentScore()}/50 = {assessmentScorePercentage()}%
                  </b>
                </p>
              </div>
              <p
                style={{
                  padding: "0 1rem",
                }}
              >
                The pass rate for this test is 70% - 35 correct questions out of
                50.
              </p>
            </div>
          )}
        </div>
        <div className="w-100 d-flex justify-content-end mt-2 mr-2">
          <Link to="/profile" className="btn btn-primary px-3">
            Back to My Account
          </Link>
        </div>
      </div>
    </div>
  );
};

MolecularOnboarding.propTypes = {
  appData: any,
  readingList: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  readingListDocs: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
      agreementText: string.isRequired,
      typeCode: string.isRequired,
    })
  ),
  markDocumentReadFunc: func.isRequired,
  molecularAssessmentLoading: bool,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
  readingList: state.core.umbracoContent.molecularReadingList,
  readingListDocs: state.core.umbracoContent.molecularReadingListDocs,
  molecularReadingListLoading: state.core.molecularReading.isLoading,
  molecularAssessmentLoading: state.core.molecularAssessment.isLoading,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadMolecular,
  postMolecularFormsFunc: postMolecularForms,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(MolecularOnboarding);
